// @ts-nocheck
import * as types from 'appRedux/actions/project_budget';
import {
  GET_PROJECT_BY_ID_REQUEST,
  GET_PROJECT_BY_ID_SUCCESS,
} from 'appRedux/actions/projects';

const initialState = {
  projectBudget: {},
  selectedProject: {},

  selectedTab: null,
  selectedPage: null,
  isTabEdited: false,
};

function budgetReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_PROJECT_BUDGET_REQUEST:
      return {
        ...state,
        projectBudget: {},
      };
    case types.GET_PROJECT_BUDGET_SUCCESS:
      return {
        ...state,
        projectBudget: action.payload.data,
      };
    case types.SELECT_PROJECT:
      return {
        ...state,
        selectedProject: action.payload.project,
      };

    case GET_PROJECT_BY_ID_REQUEST:
      return {
        ...state,
        selectedProject: {},
      };

    case GET_PROJECT_BY_ID_SUCCESS:
      return {
        ...state,
        selectedProject: action.payload,
      };

    case types.SELECT_PROJECT_BUDGET_TAB:
      return {
        ...state,
        selectedTab: action.payload.tab,
        selectedPage: action.payload.page,
      };

    case types.SELECT_PROJECT_BUDGET_PAGE:
      return {
        ...state,
        selectedPage: action.payload.page,
      };

    case types.UPDATE_TAB_EDITED_STATE:
      return {
        ...state,
        isTabEdited: action.payload.tabEdited,
      };
    default: {
      return state;
    }
  }
}

export default budgetReducer;
